import { useRouter } from 'next/router';

import { BASE_PATH } from 'shared/constants';
import { formatQuery } from 'shared/utils';

const convertRouteObjectToUrl = (to: NextRouterURL) => {
  const searchString = to.query ? `?${formatQuery(to.query)}` : '';
  return `${BASE_PATH}${to.pathname}${searchString}`;
};

type NextRouterURL = {
  pathname: string;
  query?: { [key: string]: string | number };
};

type OpenInNewTabProps = {
  clickEvent: React.MouseEvent;
  to: NextRouterURL;
};

const useOptionallyOpenInNewTab = () => {
  const router = useRouter();
  // Checks whether either key is being pressed at time of click event

  return ({ clickEvent, to }: OpenInNewTabProps) => {
    const isNewTabKeyActive = clickEvent.metaKey || clickEvent.ctrlKey;
    if (isNewTabKeyActive) {
      const url = convertRouteObjectToUrl(to);
      window.open(url, '_blank');
    } else {
      router.push(to);
    }
  };
};

export default useOptionallyOpenInNewTab;
